export const providerTypes = {
    desktop: 'desktop',
    git: 'git',
    google: 'google',
    local: 'local'
};
